module.exports = __webpack_public_path__ + "static/img/rankFirst.c9962ed3.png";